import onMessage from './onMessage';
import onAssign from './onAssign';
import onConversationStatusUpdate from './onConversationStatus';
import onNewConversation from './onNewConversation';

export default { onMessage, onAssign, onConversationStatusUpdate, onNewConversation };
